module.exports = __webpack_public_path__ + "img/1525824955.a347d129.jpg";